// Mobile-as-webapp entry. ZKX's RN bundle uses shim.js/global.js (react-native-quick-crypto,
// get-random-values). On web, the browser already provides crypto + getRandomValues so we skip.
import 'react-native-gesture-handler'
import 'expo-asset'

import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

import AppInit from './AppInit'

// Boot progress milestone: the main entry chunk has downloaded, parsed and is
// now executing. See #zkx-loader controller in public/index.html.
window.__zkxBoot?.set(0.25)

const rootTag = createRoot(document.getElementById('root') ?? document.getElementById('main'))
rootTag.render(createElement(AppInit))
